const pbFontFamily = [
  "Alfa Slab One",
  "Anton",
  "Arima Madurai",
  "Arimo",
  "Athiti",
  "Bahianita",
  "Baloo Bhaina",
  "Barlow",
  "Barlow Condensed",
  "Bungee",
  "Bungee Inline",
  "Bungee Outline",
  "Bungee Shade",
  "Cabin",
  "Chonburi",
  "Cormorant Upright",
  "Crimson Pro",
  "Dancing Script",
  "Dosis",
  "EB Garamond",
  "Exo",
  "Fira Sans",
  "Hepta Slab",
  "Inconsolata",
  "Inter",
  "Itim",
  "Josefin Sans",
  "Judson",
  "Jura",
  "K2D",
  "Lexend",
  "Literata",
  "Lobster",
  "Lora",
  "Maven Pro",
  "Merriweather",
  "Montserrat",
  "Mulish",
  "Niramit",
  "Noto Serif",
  "Open Sans",
  "Oswald",
  "Pattaya",
  "Paytone One",
  "Philosopher",
  "Play",
  "Playfair Display",
  "Prata",
  "Quicksand",
  "Raleway",
  "Roboto",
  "Roboto Slab",
  "Rokkit",
  "Source Sans Pro",
  "Sriracha",
  "Taviraj",
  "Thasadith",
  "Tinos",
  "Trirong",
  "VT323",
  "Work Sans",
  "Yeseva One"
];
const pbFontWeight = {
  regular: 400,
  medium: 500,
  bold: 700
};
const fontWeightQueryParams = Object.values(pbFontWeight).join(";");
const fontQueryParams = pbFontFamily.map((font) => {
  return `family=${encodeURIComponent(font)}:wght@${fontWeightQueryParams}`;
}).join("&");

export { fontQueryParams, pbFontFamily, pbFontWeight };
